import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import OperatorCover from "@/components/OperatorCover";
import { api, formatGBP } from "@/lib/api";
import { Flame, ExternalLink, Star, MapPin } from "lucide-react";

export default function Deals() {
  const [deals, setDeals] = useState(null);

  useEffect(() => {
    api.deals({ limit: 16 }).then(setDeals);
  }, []);

  return (
    <div className="App">
      <Nav />
      <div className="bg-gradient-to-b from-terracotta/20 to-sand">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <span className="label-eyebrow">Hot right now</span>
          <h1 className="font-display font-extrabold text-4xl sm:text-5xl mt-2" data-testid="deals-title">
            <Flame className="inline w-10 h-10 text-terracotta" /> Cheapest UK caravan parks
          </h1>
          <p className="text-ink/70 mt-3 max-w-2xl">
            Lowest per-night prices for a 3-night break in the next month. Updated hourly.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        {!deals ? (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
            {Array.from({ length: 8 }).map((_, i) => <div key={i} className="aspect-[3/4] rounded-xl skeleton-shimmer" />)}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4" data-testid="deals-grid">
            {deals.deals.map((p, i) => (
              <Link
                to={`/park/${p.slug}`}
                key={p.slug}
                className={`relative group rounded-2xl overflow-hidden border border-border bg-white hover:-translate-y-1 hover:shadow-lg transition-all ${i === 0 ? "ring-2 ring-terracotta" : ""}`}
                data-testid={`deal-card-${p.slug}`}
              >
                <div className="aspect-[4/3] overflow-hidden relative">
                  <OperatorCover park={p} />
                </div>
                {i === 0 && <span className="absolute top-3 left-3 bg-terracotta text-white text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded-full">Cheapest UK</span>}
                <div className="absolute top-3 right-3 bg-white/90 backdrop-blur rounded-full px-2 py-1 text-xs font-semibold flex items-center gap-1">
                  <Star className="w-3 h-3 fill-terracotta text-terracotta" />{p.rating}
                </div>
                <div className="p-4">
                  <div className="label-eyebrow text-[10px]">{p.operator}</div>
                  <h3 className="font-display font-semibold text-lg mt-1 leading-snug">{p.name}</h3>
                  <div className="text-xs text-ink/60 inline-flex items-center gap-1 mt-1"><MapPin className="w-3 h-3" />{p.region}</div>
                  <div className="mt-3 flex items-end justify-between">
                    <div>
                      <div className="text-[10px] uppercase tracking-wider text-ink/50">from</div>
                      <div className="font-display text-2xl font-bold text-forest leading-none">{formatGBP(p.pricing.per_night)}<span className="text-xs font-medium text-ink/60"> /night</span></div>
                    </div>
                    <span className="text-xs inline-flex items-center gap-1 text-forest">View <ExternalLink className="w-3 h-3" /></span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
